var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.Field)?_c('span',{class:'state' + _vm.Field.Value},[_vm._v(_vm._s(_vm.Field.Title))]):_c('span',{staticClass:"'state1'"},[_vm._v(" 未配置参数")])])
}
var staticRenderFns = []

export { render, staticRenderFns }